"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CONTENTFUL_ATTESTATIONS = exports.UPDATE_ALL_ZUORA_INVOICE_OWNER = exports.UPDATE_ZUORA_INVOICE_OWNER = exports.UPDATE_OTHER_PAYMENT_METHOD = exports.MUTATE_SEND_DD_MANDATE_CONFIRMATION_EMAIL = exports.MUTATE_SEND_ACH_MANDATE_CONFIRMATION_EMAIL = exports.CREATE_PAYPAL_PAYMENT_METHOD = exports.GET_PAYPAL_TOKEN = exports.PREVIEW_CANCEL_MEMBERSHIP_ORDER = exports.GET_ADDRESS_VALIDATION = exports.CREATE_CENTER_MEMBERSHIP_AND_MEMBERSHIP_TERM = exports.MAKE_RECEIPT_PAYMENT = exports.SET_CONFERENCE_USER_INFO = exports.GET_CONFERENCE_USER_INFO = exports.CREATE_INVOICE_OWNER_CHANGE_ZUORA_ORDER = exports.CREATE_QUOTE_ZUORA_ORDER = exports.DELETE_MANDATE = exports.UPDATE_MANDATE = exports.CREATE_MANDATE = exports.GET_ZUORA_RATE_PLANS = exports.GET_ZUORA_RATE_PLAN_OVERRIDE = exports.GET_ORDER_CREATION_DATA = exports.GET_ORDER_PREVIEW = exports.GET_INTL_ADDRESS_VALIDATION = exports.GET_INTL_COMPLETE_ADDRESS_VALIDATION = exports.GET_USA_COMPLETE_ADDRESS_VALIDATION = exports.GET_USA_ADDRESS_VALIDATION = exports.GET_ADDRESS_AUTOCOMPLETE_ITEMS = exports.GET_MULTI_HOSTED_PAGE_SIGNATURE = exports.GET_HOSTED_PAGE_SIGNATURE = exports.SUBSCRIPTION_TOGGLE = exports.CREATE_ZUORA_ORDER = exports.UPDATE_ZUORA_ACCOUNT = exports.GET_ZUORA_ACCOUNT = void 0;
exports.GET_ZUORA_ACCOUNT = `
query getZuoraAccount($skipAccountCreation: Boolean, $isCreateOrder: Boolean, $isOtherPayments: Boolean, $orgInvoiceCheckout: JSON, $isFirmInviteAccepted: Boolean, $cartCurrency: String, $paymentMethodId: String) {
  getZuoraAccount(skipAccountCreation: $skipAccountCreation, isCreateOrder: $isCreateOrder, isOtherPayments: $isOtherPayments, orgInvoiceCheckout: $orgInvoiceCheckout, isFirmInviteAccepted: $isFirmInviteAccepted, cartCurrency: $cartCurrency, paymentMethodId: $paymentMethodId) {
      success
      billToContact {
        firstName
        lastName
        company: billToCompanyName__c
        addressLine1: address1
        addressLine2: address2
        city
        state
        zipCode
        country
      }
      basicInfo {
        id
        name
        defaultPaymentMethod {
          id
        }
        CreditHold__c
        currency
      }
      creditCards {
        cardHolderInfo {
          cardHolderName
        }
        defaultPaymentMethod
        id
        expirationMonth
        cardNumber
        expirationYear
        cardType
        storeCard__c
      }
      paymentMethods {
        success
        association {
          zuoraId
          defaultPaymentMethodId
          paymentGateway
          bankTransfer {
            bankTransferType
            IBAN
            accountNumber
            bankCode
            branchCode
            identityNumber
            accountHolderInfo {
                accountHolderName
                email
                phone
                addressLine1
                addressLine2
                state
                country
                city
                zipCode
            }
            id
            isDefault
            accountKey
            status
            bankIdentificationNumber
            storeCard__c
          }
          creditCards {
            cardHolderInfo {
              cardHolderName
            }
            defaultPaymentMethod
            id
            expirationMonth
            cardNumber
            expirationYear
            cardType
            storeCard__c
            status
          }
          paypal {
            id
            BAID
            email
            bankIdentificationNumber
            accountKey
            isDefault
            storeCard__c
            status
          }
          ach {
            id
            accountHolderInfo {
              accountHolderName
              email
              phone
              addressLine1
              addressLine2
              state
              country
              city
              zipCode
            }
            bankABACode
            bankAccountNumber
            bankAccountType
            bankName
            bankAccountName
            isDefault
            storeCard__c
            status
          }
        }
        cima {
          zuoraId
          defaultPaymentMethodId
          paymentGateway
          bankTransfer {
            bankTransferType
            IBAN
            accountNumber
            bankCode
            branchCode
            identityNumber
            accountHolderInfo {
                accountHolderName
                email
                phone
                addressLine1
                addressLine2
                state
                country
                city
                zipCode
            }
            id
            isDefault
            accountKey
            status
            bankIdentificationNumber
            storeCard__c
          }
          creditCards {
            cardHolderInfo {
              cardHolderName
            }
            defaultPaymentMethod
            id
            expirationMonth
            cardNumber
            expirationYear
            cardType
            storeCard__c
            status
          }
          paypal {
            id
            BAID
            email
            bankIdentificationNumber
            accountKey
            isDefault
            storeCard__c
            status
          }
          ach {
            id
            accountHolderInfo {
              accountHolderName
              email
              phone
              addressLine1
              addressLine2
              state
              country
              city
              zipCode
            }
            bankABACode
            bankAccountNumber
            bankAccountType
            bankName
            bankAccountName
            isDefault
            storeCard__c
            status
          }
        }
      }
      subscriptions {
        id
        orderNumber: OrderNumber__c
        subscriptionStartDate
        billToAddressLine1: BillToAddressLine1__c
        billToAddressLine2: BillToAddressLine2__c
        billToCity: BillToCity__c
        billToState: BillToState__c
        billToPostalCode: BillToPostalCode__c
        billToCountry: BillToCountry__c
        shipToAddressLine1: ShipToAddressLine1__c
        shipToAddressLine2: ShipToAddressLine2__c
        shipToCity: ShipToCity__c
        shipToState: ShipToState__c
        shipToPostalCode: ShipToPostalCode__c
        shipToCountry: ShipToCountry__c
      }
    }
  }
`;
exports.UPDATE_ZUORA_ACCOUNT = `
  mutation updateZuoraAccount($accountData: ZuoraAccountData) {
    updateZuoraAccount(accountData: $accountData) {
      success
      reasons {
        message
        code
      }
    }
  }
`;
exports.CREATE_ZUORA_ORDER = `
  mutation createOrder($paymentMethodId: String!, $shippingAddress: Address!, $billingAddress: Address!, $saveCreditCard: Boolean!, $hasAutoPay: Boolean!, $paymentOption: String, $isCreditCardSaved: Boolean, $orderNumber: String, $sfAccountId: String,  $membershipAutoRenewEnabled: Boolean, $activeMembershipSubscription: JSON, $centerMembershipParams: CenterMembershipOrderPayload, $isCenterMembershipRenewal: Boolean, $attestationTexts: [String], $membershipProratedPrice: Float, $optForAutoRenewProducts: [RenewableProductsStatus], $isSectionsCredentialsRenewal: Boolean, $learningPathway: String, $qualificationLevelStatus: String, $isCIMA: Boolean, $isRenewalSeasonOverride: Boolean, $isAchPayment: Boolean, $renewalDateOverride: String, $paymentMethod: String, $isFLPUpgrade: Boolean, $activeFLPSubscription: JSON, $isFlpSwitchOrUpgrade: Boolean, $membershipRefund: Float, $isEckohRenewal: Boolean, $isUserFBUpgradingMembership: Boolean, $isFlpRenewal: Boolean, $primaryAddressCountry: String, $isClickedMembershipUpgrade: Boolean, $isEPAsCompleted: Boolean, $hasItemWithThreeMonthRuleProration: Boolean, $isPERCompleted: Boolean, $claimGiftAid: Boolean, $isL7CandidateOrAffiliateCoreUpgrade: Boolean, $isCimaApprenticeLapsedRenewal: Boolean, $isApprenticeCandidateForRenewal: Boolean,$isApprenticeCimaRegularLapsedRenewal: Boolean, $isApprenticeCimaAffiliateLapsedRenewal: Boolean, $isApprenticeCimaResignedRenewal: Boolean, $isApprenticeRegularForRenewal: Boolean, $isApprenticeAffiliateForRenewal: Boolean, $isOrderPaidByFirm: Boolean, $isCimaEntityInvite: Boolean, $isAicpaEntityInvite: Boolean, $useVitalSourcePriceCorrection: Boolean, $cimaMembershipTermIsTenYears: Boolean, $poNumber: String, $removeProration: Boolean, $isActiveFcmaRenewal: Boolean, $isInLatestCycle: Boolean ) {
    createOrder(paymentMethodId: $paymentMethodId, shippingAddress: $shippingAddress, billingAddress: $billingAddress, saveCreditCard: $saveCreditCard, hasAutoPay: $hasAutoPay, paymentOption: $paymentOption, isCreditCardSaved: $isCreditCardSaved, orderNumber: $orderNumber, sfAccountId: $sfAccountId, membershipAutoRenewEnabled: $membershipAutoRenewEnabled, activeMembershipSubscription: $activeMembershipSubscription, centerMembershipParams: $centerMembershipParams, isCenterMembershipRenewal: $isCenterMembershipRenewal, attestationTexts: $attestationTexts, membershipProratedPrice: $membershipProratedPrice, optForAutoRenewProducts: $optForAutoRenewProducts, isSectionsCredentialsRenewal: $isSectionsCredentialsRenewal, learningPathway: $learningPathway, qualificationLevelStatus: $qualificationLevelStatus, isCIMA: $isCIMA, isRenewalSeasonOverride: $isRenewalSeasonOverride, isAchPayment: $isAchPayment, renewalDateOverride: $renewalDateOverride, paymentMethod: $paymentMethod, isFLPUpgrade: $isFLPUpgrade, activeFLPSubscription: $activeFLPSubscription, isFlpSwitchOrUpgrade: $isFlpSwitchOrUpgrade, membershipRefund: $membershipRefund, isEckohRenewal: $isEckohRenewal, isUserFBUpgradingMembership: $isUserFBUpgradingMembership, isFlpRenewal: $isFlpRenewal, primaryAddressCountry: $primaryAddressCountry, isClickedMembershipUpgrade: $isClickedMembershipUpgrade, isEPAsCompleted: $isEPAsCompleted, hasItemWithThreeMonthRuleProration: $hasItemWithThreeMonthRuleProration, isPERCompleted: $isPERCompleted, claimGiftAid: $claimGiftAid, isL7CandidateOrAffiliateCoreUpgrade: $isL7CandidateOrAffiliateCoreUpgrade, isCimaApprenticeLapsedRenewal: $isCimaApprenticeLapsedRenewal, isApprenticeCandidateForRenewal: $isApprenticeCandidateForRenewal, isApprenticeCimaRegularLapsedRenewal: $isApprenticeCimaRegularLapsedRenewal, isApprenticeCimaAffiliateLapsedRenewal: $isApprenticeCimaAffiliateLapsedRenewal, isApprenticeCimaResignedRenewal: $isApprenticeCimaResignedRenewal, isApprenticeRegularForRenewal: $isApprenticeRegularForRenewal, isApprenticeAffiliateForRenewal: $isApprenticeAffiliateForRenewal, isOrderPaidByFirm : $isOrderPaidByFirm, isCimaEntityInvite: $isCimaEntityInvite, isAicpaEntityInvite: $isAicpaEntityInvite, useVitalSourcePriceCorrection: $useVitalSourcePriceCorrection, cimaMembershipTermIsTenYears: $cimaMembershipTermIsTenYears, poNumber: $poNumber, removeProration: $removeProration, isActiveFcmaRenewal: $isActiveFcmaRenewal, isInLatestCycle: $isInLatestCycle) {
      accountNumber
      invoiceNumbers
      orderNumber
      paidAmount
      commerceToolsSuccess
      paymentNumber
      status
      subscriptionNumbers
      success
      reasons {
        code
        message
      }
      isCartHasInvalidQuantities
      isCartHasRestrictedMix
      isCartContainsInvalidBundles
      isCartContainsActiveFreeTrials
      isCartContainsSubscribedFreeTrials
      isCartContainsFreeTrialsUsedWithinPeriod
      isCartContainsNonEligibleFreeTrials
      currency
    }
  }
`;
exports.SUBSCRIPTION_TOGGLE = `
	mutation subscriptionToggle($subscriptionNumber: String!, $autoRenew: Boolean!, $productName: String, $sku: String, $fcmaSubscriptionNumber: String){
		subscriptionToggle(subscriptionNumber: $subscriptionNumber, autoRenew: $autoRenew, productName: $productName, sku: $sku, fcmaSubscriptionNumber: $fcmaSubscriptionNumber) {
      success
		}
	}
`;
exports.GET_HOSTED_PAGE_SIGNATURE = `
  {
    getHostedPageSignature {
      id,
      url,
      signature,
      token,
      tenantId,
      key,
      success,
    }
  }
`;
exports.GET_MULTI_HOSTED_PAGE_SIGNATURE = `
  query getMultiHostedPageSignature($entity: String!, $paymentMethod: String!, $currency: String!) {
    getMultiHostedPageSignature(entity: $entity, paymentMethod: $paymentMethod, currency: $currency) {
      id,
      url,
      signature,
      token,
      tenantId,
      key,
      success,
    }
  }
`;
exports.GET_ADDRESS_AUTOCOMPLETE_ITEMS = `
  query getAddressAutocomplete($prefix: String) {
    getAddressAutocomplete(prefix: $prefix) {
      text
      streetLine
      city
      state
    }
  }
`;
exports.GET_USA_ADDRESS_VALIDATION = `
  query getUsaAddressValidation($addressLine1: String!, $addressLine2: String, $city: String!, $state: String!, $zipCode: String) {
    getUsaAddressValidation(addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, zipCode: $zipCode) {
      validationNeeded
      shippingAddress {
        valid
        reason
        suggestions {
          candidateIndex
          shortSuggestion {
            deliveryLine1
            deliveryLine2
            country
          }
          fullSuggestion {
            street
            streetSec
            city
            state
            zipcode
            county
            country
          }
          footnotes
        }
      }
      isEmbargoed
    }
  }
`;
exports.GET_USA_COMPLETE_ADDRESS_VALIDATION = `
  query getUsaCompleteAddressValidation(
    $addressLine1: String!,
    $addressLine2: String,
    $city: String!,
    $state: String!,
    $zipCode: String,
    $billingAddressLine1: String!,
    $billingAddressLine2: String,
    $city2: String!,
    $state2: String!,
    $zipCode2: String) {
    getUsaCompleteAddressValidation(
    addressLine1: $addressLine1,
    addressLine2: $addressLine2,
    city: $city,
    state: $state,
    zipCode: $zipCode,
    billingAddressLine1: $billingAddressLine1,
    billingAddressLine2: $billingAddressLine2,
    city2: $city2,
    state2: $state2,
    zipCode2: $zipCode2) {

      shippingAddressValidation {
          validationNeeded
            shippingAddress {
              valid
              reason
              suggestions {
                candidateIndex
                shortSuggestion {
                  deliveryLine1
                  deliveryLine2
                  country
                }
                fullSuggestion {
                  street
                  streetSec
                  city
                  state
                  zipcode
                  county
                  country
                }
                footnotes
              }
            }
          isEmbargoed
      }

      billingAddressValidation {
        validationNeeded
          shippingAddress {
          valid
          reason
          suggestions {
            candidateIndex
            shortSuggestion {
            deliveryLine1
            deliveryLine2
            country
            }
            fullSuggestion {
            street
            streetSec
            city
            state
            zipcode
            county
            country
            }
            footnotes
          }
          }
        isEmbargoed
      }
    }
  }
`;
exports.GET_INTL_COMPLETE_ADDRESS_VALIDATION = `
  query getIntlCompleteAddressValidation(
    $addressLine1: String!,
    $addressLine2: String,
    $city: String,
    $state: String,
    $zipCode: String!,
    $country: String!,
    $billingAddressLine1: String!,
    $billingAddressLine2: String,
    $city2: String,
    $state2: String,
    $zipCode2: String!,
    $country2: String!) {
      getIntlCompleteAddressValidation(
    addressLine1: $addressLine1,
    addressLine2: $addressLine2,
    city: $city,
    state: $state,
    zipCode: $zipCode,
    country: $country,
    billingAddressLine1: $billingAddressLine1,
    billingAddressLine2: $billingAddressLine2,
    city2: $city2,
    state2: $state2,
    zipCode2: $zipCode2,
    country2: $country2) {
      shippingAddressValidation{
        validationNeeded
        shippingAddress {
          valid
          reason
          suggestions {
            candidateIndex
            shortSuggestion {
              deliveryLine1
              deliveryLine2
              country
            }
            fullSuggestion {
              street
              streetSec
              city
              state
              zipcode
              county
              country
            }
            footnotes
          }
        }
        isEmbargoed
      }

      billingAddressValidation{
        validationNeeded
        shippingAddress {
          valid
          reason
          suggestions {
            candidateIndex
            shortSuggestion {
              deliveryLine1
              deliveryLine2
              country
            }
            fullSuggestion {
              street
              streetSec
              city
              state
              zipcode
              county
              country
            }
            footnotes
          }
        }
        isEmbargoed
      }
    }
  }
`;
exports.GET_INTL_ADDRESS_VALIDATION = `
  query getIntlAddressValidation($addressLine1: String!, $addressLine2: String, $city: String, $state: String, $zipCode: String!, $country: String!) {
    getIntlAddressValidation(addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, zipCode: $zipCode, country: $country) {
      validationNeeded
      shippingAddress {
        valid
        reason
        suggestions {
          candidateIndex
          shortSuggestion {
            deliveryLine1
            deliveryLine2
            deliveryLine3
            deliveryLine4
            country
          }
          fullSuggestion {
            street
            streetSec
            city
            state
            zipcode
            county
            country
          }
          footnotes
        }
      }
      isEmbargoed
    }
  }
`;
exports.GET_ORDER_PREVIEW = `
  query getOrderPreview($shippingAddress: Address!, $billingAddress: Address!, $membershipProductOnly: Boolean, $activeMembershipSubscription: JSON, $cart: JSON, $centerMembershipParams: CenterMembershipOrderPayload, $isSectionsCredentialsRenewal: Boolean, $isCenterMembershipRenewal: Boolean, $isRenewalSeasonOverride: Boolean, $renewalDateOverride: String, $isFlpSwitchOrUpgrade: Boolean, $isFlpRenewal: Boolean, $primaryAddressCountry: String, $currentJourneyLearningPathway: String, $isClickedMembershipUpgrade: Boolean, $isEPAsCompleted: Boolean, $hasItemWithThreeMonthRuleProration: Boolean, $isPERCompleted: Boolean, $claimGiftAid: Boolean, $isOrderPaidByFirm: Boolean, $currentMembershipEntity: String, $cimaMembershipTermIsTenYears: Boolean, $removeProration: Boolean, $isActiveFcmaRenewal: Boolean, $isInLatestCycle: Boolean ) {
    getOrderPreview(shippingAddress: $shippingAddress, billingAddress: $billingAddress, membershipProductOnly: $membershipProductOnly, activeMembershipSubscription: $activeMembershipSubscription, cart: $cart, centerMembershipParams: $centerMembershipParams, isSectionsCredentialsRenewal: $isSectionsCredentialsRenewal, isCenterMembershipRenewal: $isCenterMembershipRenewal, isRenewalSeasonOverride: $isRenewalSeasonOverride, renewalDateOverride: $renewalDateOverride, isFlpSwitchOrUpgrade: $isFlpSwitchOrUpgrade, isFlpRenewal: $isFlpRenewal, primaryAddressCountry: $primaryAddressCountry, currentJourneyLearningPathway: $currentJourneyLearningPathway, isClickedMembershipUpgrade: $isClickedMembershipUpgrade, isEPAsCompleted: $isEPAsCompleted, hasItemWithThreeMonthRuleProration: $hasItemWithThreeMonthRuleProration, isPERCompleted: $isPERCompleted, claimGiftAid: $claimGiftAid, isOrderPaidByFirm: $isOrderPaidByFirm, currentMembershipEntity: $currentMembershipEntity, cimaMembershipTermIsTenYears: $cimaMembershipTermIsTenYears, removeProration: $removeProration, isActiveFcmaRenewal: $isActiveFcmaRenewal, isInLatestCycle: $isInLatestCycle) {
      success
      legalEntity
      isFLPSwitchOrUpgrade
      previewResult {
        invoices {
          amount
          taxAmount
          amountWithoutTax
          invoiceItems {
            serviceStartDate
            serviceEndDate
            amountWithoutTax
            taxAmount
            chargeDescription
            chargeName
            chargeNumber
            processingType
            productName
            productRatePlanChargeId
            subscriptionNumber
            additionalInfo {
              quantity
              unitOfMeasure
            }
          }
        }
        creditMemos {
          amount
          taxAmount
          amountWithoutTax
          creditMemoItems {
            serviceStartDate
            serviceEndDate
            amountWithoutTax
            taxAmount
            chargeDescription
            chargeName
            chargeNumber
            processingType
            productName
            productRatePlanChargeId
            subscriptionNumber
            additionalInfo {
              quantity
              unitOfMeasure
            }
          }
        }
      }
      reasons{
        code
        message
      }
    }
  }
`;
exports.GET_ORDER_CREATION_DATA = `
	query getOrderCreationData($shippingAddress: Address!, $billingAddress: Address!, $cart: JSON, $isRenewalSeasonOverride: Boolean, $legalEntity: String, $activeMembershipSubscription: JSON) {
		getOrderCreationData(shippingAddress: $shippingAddress, billingAddress: $billingAddress, cart: $cart, isRenewalSeasonOverride: $isRenewalSeasonOverride, legalEntity: $legalEntity, activeMembershipSubscription: $activeMembershipSubscription)
	}
`;
exports.GET_ZUORA_RATE_PLAN_OVERRIDE = `
  query getZuoraRatePlanOverride($productRatePlanName: String!, $productType: String!, $isCimaOverride: Boolean!) {
    getZuoraRatePlanOverride(productRatePlanName:$productRatePlanName, productType: $productType, isCimaOverride: $isCimaOverride) {
      success
      productRatePlanId
      productRatePlanChargeId
      discountProductRatePlanChargeId
    }
  }
`;
exports.GET_ZUORA_RATE_PLANS = `
  query getZuoraRatePlans {
    getZuoraRatePlans
  }
`;
exports.CREATE_MANDATE = `
  mutation createMandate($mandateText: String!, $paymentType: String!) {
    createMandate(mandateText: $mandateText, paymentType: $paymentType) {
          success
    }
  }
`;
exports.UPDATE_MANDATE = `
  mutation updateMandate($mandateStatus: String!, $paymentType: String!) {
     updateMandate(mandateStatus: $mandateStatus, paymentType: $paymentType) {
          success
     }
  }
`;
exports.DELETE_MANDATE = `
  mutation removeMandate($paymentType: String!) {
    removeMandate(paymentType: $paymentType) {
          success
    }
  }
`;
exports.CREATE_QUOTE_ZUORA_ORDER = `
  mutation ($rootOrganizationId: String!, $orderNumber: String!, $index: Int, $renewalSeasonData: JSON, $useRemoveProration: Boolean){
    createQuoteZuoraOrders(rootOrganizationId: $rootOrganizationId, orderNumber: $orderNumber, index: $index, renewalSeasonData: $renewalSeasonData, useRemoveProration: $useRemoveProration) {
      jobIds,
      cartId,
      cartVersion,
      isLastJob,
      newSubscriptionAccessStartDate,
      newSubscriptionAccessEndDate,
    }
  }
`;
exports.CREATE_INVOICE_OWNER_CHANGE_ZUORA_ORDER = `
  mutation ($rootOrganizationId: String!, $subscriptions: [InvoiceOwnerChangeSubscriptions]!){
    createInvoiceOwnerChangeOrders(rootOrganizationId: $rootOrganizationId, subscriptions: $subscriptions)
  }
`;
exports.GET_CONFERENCE_USER_INFO = `
  {
    getConferenceUserInfo {
      companyName,
      jobTitle,
      dietaryRequirements,
      adaRequirements,
      covidWaiver,
      conferenceSafetyProtocols
    }
  }
`;
exports.SET_CONFERENCE_USER_INFO = `
  query setConferenceUserInfo($info: ConferenceUserInfoInput!) {
    setConferenceUserInfo(info: $info) {
      companyName,
      jobTitle,
      dietaryRequirements,
      adaRequirements,
      covidWaiver,
      conferenceSafetyProtocols
    }
  }
`;
exports.MAKE_RECEIPT_PAYMENT = `
  mutation payInvoice($paymentMethodId: String!, $isB2B: Boolean!, $saveCreditCard: Boolean!, $amount: Float!, $balance: Float!, $accountId: String!, $invoiceId: String!, $invoiceNumber: String!, $orderNumber: String, $installmentTerm: String, $paymentTerm: String, $invoiceEntity: String){
    payInvoice(paymentMethodId: $paymentMethodId, isB2B: $isB2B, saveCreditCard: $saveCreditCard, amount: $amount, balance: $balance, accountId: $accountId, invoiceId: $invoiceId, invoiceNumber: $invoiceNumber, orderNumber: $orderNumber, installmentTerm: $installmentTerm, paymentTerm: $paymentTerm, invoiceEntity: $invoiceEntity){
      id
      invoiceId
      number
      status
      accountId
      amount
      currency
      effectiveDate
      success
      message
      reasons {
        code
        message
      }
    }
  }
`;
exports.CREATE_CENTER_MEMBERSHIP_AND_MEMBERSHIP_TERM = `
  mutation createCenterMembershipAndMembershipTerm($centerMembership: CenterMembershipPayload){
    createCenterMembershipAndMembershipTerm(centerMembership: $centerMembership)
  }
`;
exports.GET_ADDRESS_VALIDATION = `
query getAddressValidation(
  $shippingAddress: Address,
  $billingAddress: Address
  ) {
    getAddressValidation(
      shippingAddress: $shippingAddress,
      billingAddress:  $billingAddress
    ) {
      shippingAddressValidation {
        validationNeeded
        shippingAddress {
          valid
          reason
          suggestions {
            candidateIndex
            shortSuggestion {
              deliveryLine1
              deliveryLine2
              deliveryLine3
              deliveryLine4
              country
            }
            fullSuggestion {
              street
              streetSec
              city
              state
              zipcode
              county
              country
              lat
              long
            }
            footnotes
          }
        }
        isEmbargoed
    }
    billingAddressValidation {
      validationNeeded
      shippingAddress {
        valid
        reason
        suggestions {
          candidateIndex
          shortSuggestion {
            deliveryLine1
            deliveryLine2
            deliveryLine3
            deliveryLine4
            country
          }
          fullSuggestion {
            street
            streetSec
            city
            state
            zipcode
            county
            country
            lat
            long
          }
          footnotes
        }
      }
      isEmbargoed
    }
  }
}
`;
exports.PREVIEW_CANCEL_MEMBERSHIP_ORDER = `
  query previewCancelMembershipOrder($subscriptionStartDate: String!, $subscriptionNumber: String!) {
		previewCancelMembershipOrder(subscriptionStartDate: $subscriptionStartDate, subscriptionNumber: $subscriptionNumber) {
      refundAmount
    }
	}
`;
exports.GET_PAYPAL_TOKEN = `
  query getPayPalToken($currencyCode: String, $returnUrl: String, $cancelUrl: String, $firmLegalEntity: String, $sessionIdentifier: String) {
		getPayPalToken(currencyCode: $currencyCode, returnUrl: $returnUrl, cancelUrl: $cancelUrl, firmLegalEntity: $firmLegalEntity, sessionIdentifier: $sessionIdentifier) {
      token,
      success,
      redirectUrl
    }
	}
`;
exports.CREATE_PAYPAL_PAYMENT_METHOD = `
  mutation createPayPalPaymentMethod($token: String, $storeCard: Boolean, $currency: String, $orgId: String $firmLegalEntity: String, $sessionIdentifier: String) {
    createPayPalPaymentMethod(token: $token, storeCard: $storeCard,  currency: $currency,orgId: $orgId, firmLegalEntity: $firmLegalEntity, sessionIdentifier: $sessionIdentifier) {
      success,
      id,
      legalEntity
    }
	}
`;
exports.MUTATE_SEND_ACH_MANDATE_CONFIRMATION_EMAIL = `
  mutation sendAchMandateConfirmationEmail($achMandateConfirmationEmail: AchMandateConfirmationEmail) {
    sendAchMandateConfirmationEmail(achMandateConfirmationEmail: $achMandateConfirmationEmail)
  }
`;
exports.MUTATE_SEND_DD_MANDATE_CONFIRMATION_EMAIL = `
  mutation sendDdMandateConfirmationEmail($ddMandateConfirmationEmail: AchMandateConfirmationEmail) {
    sendDdMandateConfirmationEmail(ddMandateConfirmationEmail: $ddMandateConfirmationEmail)
  }
`;
exports.UPDATE_OTHER_PAYMENT_METHOD = `
mutation updateZuoraPaymentMethodInformation($accountId: String, $paymentMethodId: String) {
  updateZuoraPaymentMethodInformation(accountId: $accountId, paymentMethodId: $paymentMethodId) {
    success
  }
}
`;
exports.UPDATE_ZUORA_INVOICE_OWNER = `
  mutation updateZuoraInvoiceOwner($orderDate: String!, $subscriptionNumber: String!) {
    updateZuoraInvoiceOwner(orderDate: $orderDate, subscriptionNumber: $subscriptionNumber) {
      success
    }
  }
`;
exports.UPDATE_ALL_ZUORA_INVOICE_OWNER = `
  mutation updateAllZuoraInvoiceOwner($orderDate: String!, $subscriptionNumbers: [String]!) {
    updateAllZuoraInvoiceOwner(orderDate: $orderDate, subscriptionNumbers: $subscriptionNumbers) {
      success
    }
  }
`;
exports.GET_CONTENTFUL_ATTESTATIONS = `
  query getContentfulAttestations {
    getContentfulAttestations
  }
`;
//# sourceMappingURL=checkout-queries.js.map